/**
 * BBC - Rap Map - Social Media share links
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 *
 */

 const shareButton = (button, copyText, copyLink, copyLinkContainer, copyLinkClose) => {
    if (!button || !copyText || !copyLink || !copyLinkContainer || !copyLinkClose) return;

    button.addEventListener('click', () => {
        if (navigator.share) {
            navigator.share({
                title: window.document.title,
                url: window.location.href,
            })
                .then(() => {
                    console.log('Thanks for sharing!');
                })
                .catch(err => console.error(err));
        } else {
            copyLinkContainer.classList.add('Sharers__copyLink--open');
        }
    });

    copyLinkClose.addEventListener('click', () => {
        copyLinkContainer.classList.remove('Sharers__copyLink--open');
    });

    copyLink.addEventListener('click', () => {
        /* Select the text field */
        copyText.select();
        /* For mobile devices */
        copyText.setSelectionRange(0, 99999);

        /* Copy the text inside the text field */
        document.execCommand('copy');

        /* Alert the copied text */
        // console.log(`Copied the text: ${copyText.value}`);

        copyLink.querySelector('span').innerHTML = 'Copied!';
        setTimeout(() => {
            copyLink.querySelector('span').innerHTML = 'Share Link';
        }, 5000);
    });
};

export default shareButton;
